import React, { useState } from 'react';
import {
    Box,
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Alert
} from '@mui/material';
import { AppHeroView } from 'components/utils/AppHeroView';
import { AppSearchInput } from 'components/widgets/AppSearchInput';

const ChassisTrackingPage = () => {
    const [trackingId, setTrackingId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [trackingData, setTrackingData] = useState(null);

    async function handleJsonApi(api, payload, onSuccess = () => { }, onFailure = () => { }, cleanUp = () => { }) {
        try {
            const response = await fetch(api, payload);
            const json = await response.json();

            if (isApiCallSucess(json)) {
                onSuccess(json);
            } else {
                onFailure(json);
            }
        } catch (error) {
            console.log(error);
            alert(error)
        } finally {
            cleanUp();
        }
    }

    function isApiCallSucess(json) {
        return json["STATUS"] === "REQUEST_SUCCESS"
    }

    const handleFetchTrackingData = (trackingId) => {
        setIsLoading(true);
        handleJsonApi(
            "https://avis-logistics.com/api/get_tracking_details.php",
            {
                method: 'POST',
                body: JSON.stringify({ "TRACKING_ID": trackingId })
            }, 
            (json) => {
                console.log("SUCCESS", json)
                setTrackingData(json["DATA"])
            },
            (json) => {
                console.log("ERROR", json)
            },
            () => {
                console.log("FINISHED")
                setIsLoading(false);
                // setSpinnerProps({ open: false, message: null })
            }
        )
    }

    const handleSearch = async () => {
        if (!trackingId.trim()) return;
        setError(null);
        setTrackingData(null);
        handleFetchTrackingData(trackingId)
    };

    return (
        <Box>
            <AppHeroView
                title="Chassis Tracking"
                description="Track your chassis delivery in real-time"
            />

            <Container maxWidth="lg" sx={{ py: 4 }}>
                {/* Search Section */}
                <Box sx={{ maxWidth: 600, mx: 'auto', mb: 4 }}>
                    <AppSearchInput
                        value={trackingId}
                        onChange={(e) => setTrackingId(e.target.value)}
                        onSearch={handleSearch}
                        placeholder="Enter Tracking ID"
                        fullWidth
                    />
                </Box>

                {/* Results Section */}
                {isLoading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <CircularProgress />
                    </Box>
                )}

                {error && (
                    <Alert severity="error" sx={{ mb: 4 }}>
                        {error}
                    </Alert>
                )}

                {trackingData && (
                    <Box>
                        {/* Tracking Updates */}
                        <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2, boxShadow: 3 }}>
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#1976d2' }}>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Tracking ID</TableCell>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Date</TableCell>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Description</TableCell>
                                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Other Info</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {trackingData.map((update, i) => (
                                        <TableRow
                                            key={`tracking-update-${i}`}
                                            sx={{
                                                backgroundColor: i % 2 === 0 ? 'action.hover' : 'background.paper',
                                                '&:hover': { backgroundColor: 'action.selected' }
                                            }}
                                        >
                                            <TableCell sx={{ fontWeight: 500 }}>{update.TRACKING_ID}</TableCell>
                                            <TableCell>{update.TRACKING_AS_ON_DATE}</TableCell>
                                            <TableCell>{update.TRACKING_DESCRIPTION}</TableCell>
                                            <TableCell>{update.OTHERS_INFO}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}
            </Container>
        </Box>
    );
};

export default ChassisTrackingPage;